import { fetchClient, type ApiResponse } from './fetchClient';

export async function request<TData = any>(
  method: string,
  path: string,
  body?: any,
  params?: any,
  responseType?: 'json' | 'stream',
) {
  const isInTestRunner = import.meta.env.VITEST_WORKER_ID !== undefined;
  if (isInTestRunner) {
    // oxlint-disable-next-line no-console
    console.error("You haven't mocked out ", method, path, 'API Call');
  }

  const response: ApiResponse<TData> = await fetchClient<TData>({
    url: path,
    method,
    params,
    data: body,
    responseType,
  });
  return response;
}
